<template>
  <div class="home" ref="DOM">
    <HeaderSwiper :list="swiperList"></HeaderSwiper>
    <div class="content">
      <HeadNav :nav="nav" :times="times"></HeadNav>
      <div
        class="newGonggao"
        @click="goClassPage(text.category.title, text.category.id)"
      >
        <div>
          <img src="../assets/images/images/gonggao2.png" />
        </div>
        <div>
          <div
            style="
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              width: 120px;
            "
          >
            家纺城公众圈用户：
          </div>
          <div class="jFName">
            {{
              (text &&
                text.publisher.nickname != "无" &&
                text.publisher.nickname) ||
              (text && text.ip_hidden)
            }}
          </div>
          <div class="contents">
            {{ text && text.published_at.substring(11, 16) }}发布了一条{{
              text && text.category.title
            }}
          </div>
        </div>
      </div>

      <SmallAdvertiseMent></SmallAdvertiseMent>

      <GongGao></GongGao>
      <HeadBoard :banner="banner"></HeadBoard>
      <!--广告位1-->
      <MoreAdvertiseMent oneId="13" twoId="14" fourId="15"/>
      <shopRecommend :leftDay="leftDay" :vipStatus="vipStatus"></shopRecommend>
      <!--广告位2-->
      <MoreAdvertiseMent oneId="16" twoId="17" fourId="18"/>
      <div>
        <Advtisement
          v-for="(item, index) in middleAdv"
          :key="index"
          :url="item.banner.url"
          :imgSrc="item.banner.thumb_url"
          :des="item.banner.description"
        ></Advtisement>
      </div>
      <HomeGoods :leftDay="leftDay" :vipStatus="vipStatus"></HomeGoods>
      <div>
        <Advtisement
          v-for="(item, index) in BottomAdv"
          :key="index"
          :url="item.banner.url"
          :imgSrc="item.banner.thumb_url"
          :des="item.banner.description"
        ></Advtisement>
      </div>

      <BackTop></BackTop>
      <HomeTab></HomeTab>
      <br />
    </div>
    <div class="orderInfo">
      <div @click="orderInfo">订阅</div>
      <div @click="connectKF">客服</div>
      <div>首页</div>
    </div>
    <!--二维码弹窗-->
    <div class="codeTc" v-if="showCode">
      <div @click="closeCode">
        <img src="../assets/images/images/closeCode.png" alt="" />
      </div>
      <div class="codeContent">
        <img :src="preImg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { getData, postData } from "../Interface/http.js";
import HeaderSwiper from "@/components/HeaderSwiper.vue";
import MoreAdvertiseMent from "@/components/moreAdvertiseMent.vue";
import HeadNav from "@/components/HeadNav.vue";
import HeadNotice from "@/components/HeadNotice.vue";
import HeadBoard from "@/components/HeadBoard.vue";
import HeadListContent from "@/components/HeadListContent.vue";
import HomeTab from "@/components/HomeTab.vue";
import DrawUp from "@/components/DrawUp.vue";
import BackTop from "@/components/BackTop.vue";
import GongGao from "@/components/GongGao.vue";
import shopRecommend from "@/components/shopRecommend";
import Advtisement from "@/components/advtisement";
import HomeGoods from "@/components/homeGoods";
import SmallAdvertiseMent from "@/components/smallAdvertisement";
let me;
export default {
  name: "home",
  data() {
    return {
      vipStatus: {},
      swiperList: [],
      banner: [],
      nav: [],
      sonNav: [],
      times: {},
      dongtaiMsg: [], //动态信息
      number: 0, //当前坐标
      middleAdv: [], //首页中部广告信息
      BottomAdv: [], //首页底部广告信息
      images: [], //客服海报
      orderImg: [], //订阅图片
      preImg: "",
      showCode: false,
      scroll: 0,
      leftDay: {
        type: ''
      }, //VIP剩余多少天数
    };
  },
  computed: {
    text() {
      return this.dongtaiMsg[this.number];
    },
  },
  components: {
    HeaderSwiper,
    HeadNav,
    HeadNotice,
    HeadBoard,
    HeadListContent,
    HomeTab,
    DrawUp,
    BackTop,
    GongGao,
    shopRecommend,
    Advtisement,
    HomeGoods,
    SmallAdvertiseMent,
    MoreAdvertiseMent
  },
  mounted() {
    me = this;
    let token = localStorage.getItem("token");
    if (!token) {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("pageparams", window.location.href);
        localStorage.setItem("startPage", "about");
        window.location.href = res.data.redirect_url;
        // window.location.href = 'http://jfc.jfbst.com/getToken';
      });
    }
    this.getSwiper();
    this.getUserStatus();
    this.getVipTimeOut();
    this.getBanner();
    this.getNav();
    this.getProvide();
    this.getTimes();
    this.getActions();
    this.$store.commit("UPDATEWORD");
    this.$store.commit("UPDATEATBINDEX", { tag: 0 });
    this.getShare();
    this.getDongtai(); //获取动态信息
    this.changeMsg();
    this.getMiddleInfo();
    this.getBottomnfo();
    me.selectKFImg();
    me.selectOrderImg();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    //查询会员到期时间
    getVipTimeOut() {
      getData("/vip/check-validity-date")
        .then((res) => {
          me.leftDay = Object.assign({},res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取用户当前的开通状态
    getUserStatus() {
      postData("/vip/is-pay", {
        type: "store",
      })
        .then((res) => {
          me.vipStatus = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleScroll() {
      this.scroll =
        document.documentElement && document.documentElement.scrollTop;
    },
    //关闭二维码
    closeCode() {
      me.showCode = false;
    },
    //展示订阅二维码
    orderInfo() {
      me.preImg = me.orderImg[0].banner.thumb_url;
      this.$nextTick(function () {
        me.showCode = true;
      });
    },
    //展示客服二维码
    connectKF() {
      me.preImg = me.images[0];
      this.$nextTick(function () {
        me.showCode = true;
      });
    },
    selectKFImg() {
      let me = this;
      getData("/recommend-lists?position=7")
        .then((res) => {
          if (res.code == 0) {
            var arr = [];
            arr = res.data.map((item) => {
              return item.banner.thumb_url;
            });
            me.images.push(...arr);
          }
        })
        .catch((err) => {});
    },
    selectOrderImg() {
      //获取订阅图片
      let me = this;
      getData("/recommend-lists?position=10").then((res) => {
        me.orderImg = res.data;
      });
    },
    //调起支付
    payMoney() {
      postData("/payment/order/create", {
        trade_type: "mp",
        plan_id: "1",
      })
        .then((res) => {
          me.onBridgeReady(res.data);
        })
        .catch((err) => {});
    },
    onBridgeReady(msg) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", msg, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        }
      });
    },
    //跳转分类页
    goClassPage(title, id) {
      // if (id > 10) {
      //   title = "家纺广告";
      // }
      // me.$router.push({ path: "/about", query: { id: id, title: title } });
    },
    //获取首页中部广告图
    getMiddleInfo() {
      getData("/recommend-lists", {
        num: 10,
        position: 8,
      }).then((res) => {
        me.middleAdv = res.data;
      });
    },
    //获取首页底部广告图
    getBottomnfo() {
      getData("/recommend-lists", {
        num: 10,
        position: 9,
      }).then((res) => {
        me.BottomAdv = res.data;
      });
    },
    //切换动态信息
    changeMsg() {
      let aa = setInterval(function () {
        let total = me.dongtaiMsg.length;
        if (me.number < me.dongtaiMsg.length - 1) {
          me.number = me.number + 1;
        } else {
          me.number = 0;
        }
        me.changeMsg();
        clearInterval(aa);
      }, 4000);
    },
    //获取动态信息
    getDongtai() {
      getData("/realtime-messages").then((res) => {
        this.dongtaiMsg = res.data;
      });
    },
    // 横幅
    getBanner() {
      getData("/recommend-lists", {
        position: 2,
      }).then((res) => {
        this.banner = res.data;
      });
    },
    // 幻灯片
    getSwiper() {
      getData("recommend-banners", {
        num: 10,
      }).then((res) => {
        this.swiperList = res.data;
      });
    },
    // 导航图标
    getNav() {
      getData("nav").then((res) => {
        res.data.map((a) => {
          this.nav.push(a);
        });
        // this.nav = res.data;
      });
    },
    // 栏目供求
    getProvide() {
      getData("recommend-categories").then((res) => {
        let arr = { id: 10, title: "全部" };
        res.data.unshift(arr);
        this.sonNav = res.data;
      });
    },
    getTimes() {
      // statistics
      getData("statistics").then((res) => {
        this.times = res.data;
      });
    },
    getActions() {
      getData("/report/options", {}).then((res) => {
        this.$store.commit("UPDATEACTIONS", { actions: res.data });
      });
    },
    getShare() {
      //获取配置数据
      let pathname = encodeURIComponent(window.location.pathname);
      let search = encodeURIComponent(window.location.search);
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var iPad = u.indexOf("iPad") > -1;
      var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
      let anURL =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        window.location.search; //安卓地址
      let iosURL = this.$store.state.jumpUrl; //ios地址
      let result = "";
      if (isAndroid) {
        result = anURL;
      }
      if (isiOS || iPad || iPhone) {
        result = window.location.href;
      }
      //this.message=result;
      result = encodeURIComponent(result);
      getData("/oauth/credential/jssdk?debug=1&url=" + result).then((res) => {
        wx.config({
          //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见微信公众平台附录
        });
        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: '家纺城公众圈', // 分享标题
            desc: '家纺人每天都在用的线上广告平台！', // 分享描述
            link: 'http://jfc.jfbst.com/home',
            imgUrl: 'http://cdn11.jfbst.com/statics/pc/share.png', // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              // store.commit("controlStatusUserPage/showMsg", "分享成功");
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              // store.commit("controlStatusUserPage/showMsg", "您取消了操作");
            },
          });
          wx.updateTimelineShareData({
            title: '家纺城公众圈', // 分享标题
            link: 'http://jfc.jfbst.com/home',
            imgUrl: 'http://cdn11.jfbst.com/statics/pc/share.png', // 分享图标
            success: function (res) {},
            cancel: function () {},
          });
        });
      });
    },
  },
  activated() {
    let that = this;
    that.getUserStatus();
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      document.documentElement.scrollTop = that.scroll;
    });
  },
  deactivated() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.codeContent {
  width: 100%;
  height: 200px;
  padding: 20px 0;
  display: flex;
  justify-content: center;
}
.codeContent img {
  width: 150px;
  height: 200px;
}
.codeTc {
  position: fixed;
  top: 50%;
  left: 50%;
  min-height: 220px;
  width: 220px;
  z-index: 99999;
  background-color: #f5f5f5;
  opacity: 0.9;
  transform: translate(-50%, -50%);
  border-radius: 5px;
}
.codeTc > div:nth-child(1) {
  position: absolute;
  right: 5px;
  top: 5px;
}
.codeTc > div:nth-child(1) img {
  width: 20px;
  height: 20px;
}
.orderInfo {
  position: fixed;
  left: -5px;
  top: 65%;
  z-index: 99;
}

.orderInfo div {
  background-color: #882784;
  font-size: 15px;
  color: #fff;
  opacity: 0.7;
  padding: 10px;
  margin-top: 5px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  line-height: 17px;
}
.home {
  position: relative;
  height: 100vh;
  background: rgb(220, 220, 220);
}
.content {
  background: rgb(220, 220, 220);
}
.newGonggao {
  width: 355px;
  margin: 0 auto;
  background-color: #fff;
  display: flex;
  font-size: 11px;
  height: 28px;
  align-items: center;
  border-radius: 5px;
  color: #666666;
  margin-bottom: 5px;
}
.newGonggao img {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  margin-right: 10px;
}
.newGonggao > div:nth-child(1) {
  display: flex;
  align-items: center;
}
.newGonggao > div:nth-child(2) {
  display: flex;
  align-items: center;
}
.jFName {
  width: 60px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.contents {
  width: 140px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
